/* eslint-disable jsx-a11y/anchor-is-valid */
import { forwardRef, useContext } from 'react';
import { AdminTestContext } from '@orientaction/Context';
import TestMainImage from './TestMainImage';
import style from './style';

interface LeftImageProps {
  isThumbnail?: boolean;
}

// const placeholder = () => (
//   <div>
//     <p>Glissez et déposez une image ici, ou cliquez pour sélectionner un fichier</p>
//     <p>Format recommandé : PNG, JPG</p>
//   </div>
// );

const LeftImage = forwardRef<unknown, LeftImageProps>(({ isThumbnail = false }, ref) => {
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const classes = style();

  const handleFileUrlChange = (url: string) => {
    updateTest({
      test: {
        ...test.test,
        [isThumbnail ? 'thumbnail' : 'image']: url,
      },
    });
  };

  const handleDeleteFile = () => {
    updateTest({
      test: {
        ...test.test,
        [isThumbnail ? 'thumbnail' : 'image']: '',
      },
    });
  };

  const hasImage = isThumbnail ? test.test.thumbnail : test.test.image;

  return (
    <>
      <TestMainImage
        fileUrl={isThumbnail ? test.test.thumbnail : test.test.image}
        handleFileUrlChange={handleFileUrlChange}
        pathPrefix="tests"
        sectionTop={true}
        error={isThumbnail ? test?.errors?.thumbnail : test?.errors?.image}
        ref={ref as any}
        isSmaller={isThumbnail}
      />
      {hasImage && (
      <div className={classes.deleteFileTextContainer}>
        <a style={{ color: 'red', textDecoration: "none" }} href="#" onClick={(e) => { e.preventDefault(); handleDeleteFile(); }}>
          Supprimer
        </a>
      </div>
      )}
    </>
  );
});

export default LeftImage;
